// extracted by mini-css-extract-plugin
module.exports = {"text_color_white":"DialogNew_text_color_white__2g4oT"};